import { render } from "./MixView.vue?vue&type=template&id=6fdee204"
import script from "./MixView.vue?vue&type=script&lang=js"
export * from "./MixView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__